module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {}, [_c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('h3', {
    staticClass: "title is-6",
    on: {
      "click": function($event) {
        _vm.$router.push('/home/topten')
      }
    }
  }, [_vm._v("北邮人论坛")])])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-center"
  }, [_c('div', {
    staticClass: "nav-item"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9371270","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 259
// module chunks = 1